import MasterCrudPage from "@/components/MasterCrudPage";

export default function NumberingSeries() {
  return (
    <MasterCrudPage
      endpoint="/masters/numbering-series"
      title="Numbering Series"
      breadcrumbs={["Masters", "Numbering"]}
      testIdPrefix="numbering"
      initialForm={{ is_active: true, padding_length: 6, current_sequence: 0, reset_yearly: true }}
      columns={[
        { key: "module_name", label: "Module" },
        { key: "prefix_format", label: "Prefix" },
        { key: "financial_year", label: "FY" },
        { key: "current_sequence", label: "Current Seq" },
        { key: "padding_length", label: "Padding" },
      ]}
      formFields={[
        { key: "module_name", label: "Module", required: true, placeholder: "task, report..." },
        { key: "prefix_format", label: "Prefix Format", required: true, placeholder: "T360/{FY}/{SEQ}" },
        { key: "financial_year", label: "Financial Year" },
        { key: "padding_length", label: "Padding Length", type: "number" },
        { key: "current_sequence", label: "Current Sequence", type: "number" },
        { key: "reset_yearly", label: "Reset Yearly", type: "checkbox" },
        { key: "is_active", label: "Active", type: "checkbox" },
      ]}
    />
  );
}
